import { render, staticRenderFns } from "./NoteNewDialog.vue?vue&type=template&id=6b7cb4ac&"
import script from "./NoteNewDialog.vue?vue&type=script&lang=ts&"
export * from "./NoteNewDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports